/* ====== Search Redirects (Centro Repuestos) ======
   Intercepta /search y redirige a páginas de categoría/marca.
   - Normaliza tildes y mayúsculas
   - Reconoce sinónimos (Chile-friendly)
   - Si detecta MARCA + CATEGORÍA: prioriza categoría y pasa ?brand=
   ================================================== */

const SLUGS = {
  suspension: "/pages/repuestos-suspension",
  frenos: "/pages/repuestos-frenos",
  refrigeracion: "/pages/repuestos-refrigeracion",
  direccion: "/pages/repuestos-direccion",
  motor: "/pages/repuestos-motor",            // (Componentes de Motor)
  filtros: "/pages/filtros-mantenimiento",
  sensores: "/pages/sensores-bulbos",
  // Marcas
  landrover: "/pages/repuestos-land-rover",
  mazda: "/pages/repuestos-mazda",
  mg: "/pages/repuestos-mg",
  subaru: "/pages/repuestos-subaru",
  honda: "/pages/repuestos-honda",
  rover: "/pages/repuestos-rover",
};

const norm = s => (s || "")
  .toLowerCase()
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[^\p{L}\p{N}\s]/gu, " ") // limpia signos
  .replace(/\s+/g, " ")
  .trim();

// ------------ SINÓNIMOS → CATEGORÍAS ---------------
const KEYWORDS = {
  // SUSPENSIÓN
  suspension: [
    "suspension","bandeja","bandejas","bandeja suspension","horquilla","trapecio",
    "brazo suspension","brazo oscilante","bieleta","bieletas","estabilizadora",
    "barra estabilizadora","pivote","rotula","rotulas","rótula","cojinete rueda",
    "rodamiento rueda","masa rueda","resorte","resortes","amortiguador","amortiguadores",
    "tope amortiguador","cazoleta","cazoletas","kit suspension"
  ],
  // FRENOS
  frenos: [
    "freno","frenos","pastilla","pastillas","disco","discos","campana","campanas",
    "zapata","zapatas","caliper","pinza freno","bomba freno","servofreno",
    "cilindro maestro","cilindro rueda","flexible freno","manguera freno",
    "liquido frenos","sensor desgaste pastillas","kit frenos","abs freno"
  ],
  // REFRIGERACIÓN
  refrigeracion: [
    "refrigeracion","refrigeración","radiador","radiadores","tapa radiador",
    "manguera radiador","bomba de agua","termostato","electroventilador",
    "ventilador","termocontacto","depósito expansion","vaso expansion",
    "heater core","calefactor","intercooler","anticongelante"
  ],
  // DIRECCIÓN
  direccion: [
    "direccion","dirección","cremallera","caja direccion","caja de direccion",
    "bomba direccion","bomba hidraulica","bomba electrohidraulica",
    "terminal","terminales","axial","axiales","barra axial","bieleta direccion",
    "columna direccion","pitman","amortiguador direccion","fluido direccion"
  ],
  // COMPONENTES DE MOTOR
  motor: [
    "motor partes","componentes motor","piezas motor","partes internas motor",
    "empaquetadura","empaquetaduras","junta","juntas","junta culata",
    "empaquetadura tapa valvulas","reten","retenes","reten ciguenal","reten cigueñal",
    "piston","pistones","anillo","anillos","valvula","valvulas","taque","taques",
    "botadores","balancines","arbol de levas","arbol levas","cigueñal","ciguenal",
    "cadena distribucion","correa distribucion","kit distribucion","tensor",
    "polea distribucion","bomba aceite","carter","tapa valvulas"
  ],
  // FILTROS
  filtros: [
    "filtro","filtros","filtro aceite","filtro aire","filtro combustible",
    "filtro cabina","filtro polen","filtro habitaculo","kit mantencion",
    "mantencion","afinamiento","bujia","bujias","correa accesorios","correa alternador",
    "lubricantes","aceite motor"
  ],
  // SENSORES
  sensores: [
    "sensor","sensores","bulbo","bulbos","sensor oxigeno","sonda lambda",
    "maf","map","tps","ect","iat","ckp","cmp","sensor detonacion","knock sensor",
    "sensor temperatura","bulbo aceite","sensor abs","sensor velocidad",
    "check engine","testigo motor"
  ],
};

// ------------ MARCAS -------------
const BRANDS = {
  landrover: ["land rover","range rover","defender","discovery","freelander","evoque","velar"],
  mazda: ["mazda","cx5","cx-5","cx3","cx-3","cx30","cx-30","mazda 3","mazda 6","bt50","bt-50"],
  mg: ["mg","mg3","mg 3","mg5","mg 5","mg zs","mg hs","rx5"],
  subaru: ["subaru","forester","outback","xv","impreza","legacy"],
  honda: ["honda","civic","accord","crv","cr-v","hrv","hr-v","fit"],
  rover: ["rover","rover 200","rover 400","rover 600","rover 800","mini rover"]
};

// ---------- LÓGICA DE RESOLUCIÓN ----------
function findCategory(q) {
  for (const [cat, list] of Object.entries(KEYWORDS)) {
    for (const term of list) {
      if (q.includes(norm(term))) return cat;
    }
  }
  return null;
}
function findBrand(q) {
  for (const [brand, list] of Object.entries(BRANDS)) {
    for (const term of list) {
      if (q.includes(norm(term))) return brand;
    }
  }
  return null;
}
function resolveTarget(queryRaw) {
  const q = norm(queryRaw);
  if (!q) return null;
  const cat = findCategory(q);
  const brand = findBrand(q);
  if (cat && brand) return `${SLUGS[cat]}?brand=${encodeURIComponent(brand)}`;
  if (cat) return SLUGS[cat];
  if (brand) return SLUGS[brand];
  return null;
}

// --------- INTERCEPTAR FORMULARIOS /search ----------
function hookSearchForms() {
  const forms = document.querySelectorAll('form[action*="/search"]');
  forms.forEach(form => {
    if (form.__cr_hooked) return;
    form.__cr_hooked = true;
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('input[name="q"], input[type="search"]');
      const value = input ? input.value : "";
      const target = resolveTarget(value);
      if (target) {
        e.preventDefault();
        const url = target.includes("?")
          ? `${target}&q=${encodeURIComponent(value)}`
          : `${target}?q=${encodeURIComponent(value)}`;
        window.location = url;
      }
    });
  });
}

// --------- RESCATE EN /search ----------
function rescueOnSearchPage() {
  const path = location.pathname || "";
  if (!path.includes("/search")) return;
  const params = new URLSearchParams(location.search);
  const q = params.get("q") || "";
  const target = resolveTarget(q);
  if (target) {
    const url = target.includes("?")
      ? `${target}&q=${encodeURIComponent(q)}`
      : `${target}?q=${encodeURIComponent(q)}`;
    window.location.replace(url);
  }
}

// ====== CTA SECUNDARIO (funciona en /search y en el modal de Be Yours) ======
function mountSearchCTA() {
  // 1) Ubicar el contenedor del botón "Buscar …" (modal y no modal)
  const host =
    document.querySelector('search-modal[open] #predictive-search-option-search-keywords') ||
    document.querySelector('search-modal[open] .predictive-search__search-for-button') ||
    document.querySelector('#predictive-search-option-search-keywords') ||
    document.querySelector('.predictive-search__search-for-button');

  if (!host) return;

  // 2) Detectar el término q
  const urlQ = new URLSearchParams(location.search).get('q') || '';
  const inputQ = document.querySelector('search-modal [name="q"], form[action*="/search"] [name="q"]')?.value || '';
  const spanQ = host.querySelector('[data-predictive-search-search-for-text]')?.textContent || '';
  const cleanedSpanQ = spanQ.replace(/^.*Buscar\s*[“"]?/i, '').replace(/[”"]?$/,'').trim();
  const q = (inputQ || urlQ || cleanedSpanQ || '').trim();
  if (!q) return;

  // 3) Resolver destino con tu diccionario
  const target = resolveTarget(q);
  if (!target) return;

  // 4) Botón amarillo original y evitar duplicados
  const primaryBtn = host.querySelector('button, a.button, .button');
  if (!primaryBtn) return;
  if (host.querySelector('.cr-suggest-btn')) return; // ya insertado

  // 5) Crear gemelo sin "button--full-width"
  const btn = document.createElement('a');
  btn.href = target.includes('?') ? `${target}&q=${encodeURIComponent(q)}` : `${target}?q=${encodeURIComponent(q)}`;
  btn.textContent = 'Ir a la página sugerida';

  const cls = (primaryBtn.className || '')
    .split(/\s+/)
    .filter(c => c && c !== 'button--full-width')
    .join(' ');
  btn.className = (cls || 'button') + ' cr-suggest-btn';
  btn.style.marginLeft = '12px';
  btn.style.whiteSpace = 'nowrap';

  // 6) Insertar al lado del amarillo y forzar layout en fila
  host.insertBefore(btn, primaryBtn.nextSibling);
  host.style.display = 'flex';
  host.style.flexWrap = 'wrap';
  host.style.gap = '12px';
  host.style.alignItems = 'center';
  primaryBtn.style.width = 'auto';

  // 7) Reintento por si el modal re-renderiza
  setTimeout(() => {
    if (!btn.isConnected) mountSearchCTA();
  }, 150);
}



 // ====== INIT - PRUEBA TEMPORAL ======
document.addEventListener('DOMContentLoaded', () => {
  // Auditoría del buscador nativo.
  // Redirecciones automáticas desactivadas.
  // CTA de página sugerida desactivado temporalmente.
});

